import { formatPrice } from "@/utils/number";
import { ChangeEvent, FC } from "react";
import "./style.scss";

interface InputCurrencyPropTypes {
  value: string;
  onChange: (e: string) => void;
  disabled?: boolean;
  width?: string;
}

const InputCurrency: FC<InputCurrencyPropTypes> = ({
  value,
  onChange = () => {},
  disabled,
  width,
}) => {
  const onChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    onChange(formatPrice(value));
  };

  return (
    <div
      className={
        "input-currency-component-wrapper" + (disabled ? " disabled" : "")
      }
      style={{ width: width ? width : "400px" }}
    >
      <span className="currency-code">Rp</span>
      <input
        type="text"
        value={value}
        onChange={onChangeInput}
        disabled={disabled}
        style={{ width: width ? `calc(${width} - 34px)` : "" }}
      />
    </div>
  );
};

export default InputCurrency;
